import React,{useEffect} from "react";
import { Form, Input, Button, Select, message, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";

import { Fetch, Get } from "../../../utils";

const { Option } = Select;
const SignUp = () => {

  const getinterestlist =async()=>{
   await Get("/apis/interests")
  }
useEffect(()=>{
  getinterestlist()
},[])
  const onFinish = async (values) => {
    // const data = await Fetch(`/auth/register`, "POST", {
    //   name: values.name,
    //   phone: values.phone,
    //   email: values.email,
    //   password: values.password,
    //   role: values.type,
    // });
    // if (data.code === 500) {
    //   message.error("Please add all the required fields and try again");
    // } else {
    //   message.success("Register successfully kindly do login");
    // }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
      }}
    >
      <Form name="normal_login" className="login-form" onFinish={onFinish}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Avatar size={100} icon={<UserOutlined />} />
        </div>

        {/* <Form.Item
          name="type"
          rules={[{ required: true, message: "Please select your role" }]}
        >
          <Select placeholder="Please select role" allowClear>
            <Option value="1">Shopkeeper</Option>
            <Option value="0">Customer</Option>
          </Select>
        </Form.Item>
        <Form.Item
          style={{ marginTop: 20 }}
          name="name"
          rules={[
            {
              required: true,
              message: "Please input your full name!",
            },
          ]}
        >
          <Input placeholder="Enter your full name" />
        </Form.Item>

        <Form.Item
          style={{ marginTop: 20 }}
          name="phone"
          rules={[
            {
              required: true,
              message: "Please input your phone number!",
            },
          ]}
        >
          <Input placeholder="Enter your phone number" />
        </Form.Item>
        <Form.Item
          style={{ marginTop: 20 }}
          name="email"
          rules={[
            {
              type: "email",
              message: "The input is not valid E-mail!",
            },
            {
              required: true,
              message: "Please input your E-mail!",
            },
          ]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>

        <Form.Item
          name="password"
          style={{ marginTop: 20 }}
          rules={[
            {
              required: true,
              message: "Please input your Password!",
            },
          ]}
        >
          <Input type="password" placeholder="Enter your password" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Register
          </Button>
        </Form.Item> */}
      </Form>
    </div>
  );
};
export default SignUp;
